module.exports = __webpack_public_path__ + "media/images/vp/sample.taskimagethumb_-6c50266383b5a52096119a7b4ca388a8.png";